import { render, staticRenderFns } from "./BranchList.vue?vue&type=template&id=1946717a&scoped=true&"
import script from "./BranchList.vue?vue&type=script&lang=ts&"
export * from "./BranchList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946717a",
  null
  
)

export default component.exports